<template>
  <v-app-bar  dense app color="primary">
    <v-app-bar-nav-icon color='claro' @click.stop="abrirBarra"></v-app-bar-nav-icon>
    <v-toolbar-title class="claro--text"><h5>Bienvenid@ {{ nombre }} {{ apellido }}</h5> </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-icon @click="onLogout" color="claro">mdi-logout</v-icon>
  </v-app-bar>
</template>

<script>
export default {
  name: "BarraPrincipal",
  data() {
    return {      
      nombre: "",
      apellido: "",
    };
  }, 

  created() {
    this.nombre = sessionStorage.getItem("nombre");
    this.apellido = sessionStorage.getItem("apellido");
  },
  methods: {
    abrirBarra(){         
      this.$emit('abrir', true)
    },

    onLogout(){

        // let st = this.$store
        // let tr = this.$router

        sessionStorage.removeItem('data')
        this.$router.push({name:'Login'})

        // var auth2 = gapi.auth2.getAuthInstance();
        // auth2.signOut().then(function () {
        //     st.dispatch("doLogout");
        //     window.location = "https://mail.google.com/mail/u/0/?logout&hl=en";
        //     tr.push({name: 'AccesoAlumno'})
        // });        
    }
  },
};
</script>